import script from "./TypographyTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./TypographyTitle.vue?vue&type=script&setup=true&lang=js"

import "./TypographyTitle.vue?vue&type=style&index=0&id=2c8e3fa6&lang=scss"

const __exports__ = script;

export default __exports__